import { useMediaHandler } from "../../hooks/useMediaHandler";

const Video = ({ fileUrl, attachment = {}, onError, ...rest }) => {
  const { mediaRef, handleError } = useMediaHandler({ src: fileUrl, onError });

  return (
    <div className="video-attachment">
      <video
        controls
        className="video-player"
        preload="metadata"
        ref={mediaRef}
        {...rest}
      >
        <source
          src={fileUrl}
          //@ts-ignore
          type={attachment?.content_type || "video/mp4"}
          onError={handleError}
        />
        Your browser does not support the video element.
      </video>
    </div>
  );
};
export default Video;
